var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4.75C12.972 4.75 4 13.722 4 24.75C4 35.778 12.972 44.75 24 44.75C35.028 44.75 44 35.778 44 24.75C44 13.722 35.028 4.75 24 4.75ZM24 40.75C15.178 40.75 8 33.572 8 24.75C8 15.928 15.178 8.75 24 8.75C32.822 8.75 40 15.928 40 24.75C40 33.572 32.822 40.75 24 40.75Z",
    fill: "#ACC549"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.998 27.9241L15.4 23.3341L12.576 26.1661L20.0021 33.5761L33.4141 20.1641L30.5861 17.3361L19.998 27.9241Z",
    fill: "#ACC549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.f156b7a3a583d53465fab35dbd05b7f6.svg";
export { ForwardRef as ReactComponent };